import FoodAnalysis from './Analysis'
import HealthColumn from './column/Health'
import PortionColumn from './column/Portion'
import CalorieColumn from './column/Calorie'

export default {
	FoodAnalysis,
	HealthColumn,
	PortionColumn,
	CalorieColumn
}
